import React from 'react';
import {Container} from 'react-bootstrap';
import {DOCUMENT_TITLE} from 'Common/constants/layout';
import NotifyMeListTable from './NotifyMeListTable';

const NotifyMe = (): JSX.Element => {
  document.title = DOCUMENT_TITLE.NOTIFY_ME;
  return (
    <div className="page-content">
      <Container fluid={true}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Notified Product</h4>
        </div>
        <NotifyMeListTable />
      </Container>
    </div>
  );
};

export default NotifyMe;
